export enum NdaActionTypes {
  CHANGE_NDA_PDF_PAGES_COUNT = 'CHANGE_NDA_PDF_PAGES_COUNT',
  CHANGE_NDA_STATUS = 'CHANGE_NDA_STATUS',
  CHANGE_INITIAL_PDF = 'CHANGE_INITIAL_PDF',
  CHANGE_SIGNED_PDF = 'CHANGE_SIGNED_PDF',
}
